import { useMemo } from 'react'

const FRASES_FALLBACK = [
  'lo que registras, lo puedes entender. lo que entiendes, puedes cambiarlo.',
  'cada registro es información. la información vale.',
  'los patrones pequeños son los que más pesan al final del mes.',
  'no hay gastos perfectos. hay información para decidir mejor.',
]

export function useInsights(gastos, metas) {
  return useMemo(() => {
    // Todos los gastos — Obligación se incluye en los totales pero nunca genera un insight propio
    const soloGastos = gastos.filter(g => g.tipo === 'gasto')
    const totalGastos = soloGastos.reduce((a, g) => a + g.monto, 0)

    // Regla 1: progreso de meta
    if (metas.length > 0) {
      const m = metas[0]
      const pct = m.objetivo > 0 ? Math.round((m.acumulado / m.objetivo) * 100) : 0
      if (pct >= 75 && pct < 100) return { text: `llevas el ${pct}% de "${m.nombre}". ya casi.`, type: 'positive' }
      if (pct >= 50) return { text: `ya llevas la mitad en "${m.nombre}".`, type: 'positive' }
    }

    // Regla 2: categoría dominante
    if (soloGastos.length >= 3 && totalGastos > 0) {
      const cats = soloGastos.reduce((a, g) => ({ ...a, [g.categoria]: (a[g.categoria] || 0) + g.monto }), {})
      const [topCat, topMonto] = Object.entries(cats).sort((a, b) => b[1] - a[1])[0]
      if (topMonto / totalGastos > 0.4) {
        return { text: `${topCat} concentra el mayor gasto del mes. ¿lo esperabas?`, type: 'neutral' }
      }
    }

    // Regla 3: gastos impulsivos (% sobre el total real, incluyendo Obligación)
    if (soloGastos.length >= 3 && totalGastos > 0) {
      const impTotal = soloGastos.filter(g => g.emocion === 'Impulsivo').reduce((a, g) => a + g.monto, 0)
      if (impTotal / totalGastos > 0.25) {
        return {
          text: `el ${Math.round(impTotal / totalGastos * 100)}% fue impulsivo este mes. ¿algo lo provocó?`,
          type: 'warning',
        }
      }
    }

    // Regla 4: comparación semanal
    if (soloGastos.length >= 3) {
      const ahora = Date.now()
      const inicioSemana = ahora - (new Date().getDay() * 86400000)
      const inicioSemanaAnterior = inicioSemana - 7 * 86400000
      const inicioMes = new Date(); inicioMes.setDate(1); inicioMes.setHours(0,0,0,0)

      if (inicioSemanaAnterior >= inicioMes.getTime()) {
        const estaS = soloGastos.filter(g => new Date(g.fecha).getTime() >= inicioSemana)
          .reduce((a, g) => a + g.monto, 0)
        const pasadaS = soloGastos.filter(g => {
          const t = new Date(g.fecha).getTime()
          return t >= inicioSemanaAnterior && t < inicioSemana
        }).reduce((a, g) => a + g.monto, 0)

        if (pasadaS > 0 && estaS < pasadaS * 0.8)
          return { text: 'esta semana gastaste menos que la anterior.', type: 'positive' }
        if (pasadaS > 0 && estaS > pasadaS * 1.3)
          return { text: '¿algo pasó esta semana? el gasto subió más de lo usual.', type: 'neutral' }
      }
    }

    // Regla 5: sin movimientos
    if (gastos.length === 0)
      return { text: 'empieza cuando quieras. sin apuro.', type: 'positive' }

    // Fallback
    return { text: FRASES_FALLBACK[new Date().getDate() % FRASES_FALLBACK.length], type: 'positive' }
  }, [gastos, metas])
}
